import { type JSONSchema } from '@conduit-client/jsonschema-validate';
import {
    type WireAdapterConstructor,
    type WireAdapterResult,
    type WireConfigValue,
} from '@conduit-client/lwc-types';
import { CommandWireAdapterConstructor, type GetCommand } from './utils';
import type { NamedService, ServiceDescriptor } from '@conduit-client/utils';

export class LWCWireBindingsService {
    bind<Data, Config extends WireConfigValue = WireConfigValue>(
        getCommand: GetCommand<Data, Config>,
        configSchema?: JSONSchema,
        exposeRefresh = false
    ): WireAdapterConstructor<Config, WireAdapterResult<Data>, {}> {
        return class extends CommandWireAdapterConstructor<Data, Config> {
            configSchema = configSchema;
            exposeRefresh = exposeRefresh;
            getCommand() {
                return getCommand(this.config!);
            }
        };
    }
}

export type LWCWireBindingsServiceDescriptor = ServiceDescriptor<
    LWCWireBindingsService,
    'lwcWireBindings',
    '1.0'
>;

export type NamedLWCWireBindingsService<Name extends string = 'lwcWireBindings'> = NamedService<
    Name,
    LWCWireBindingsService
>;

export function buildServiceDescriptor(): LWCWireBindingsServiceDescriptor {
    return {
        type: 'lwcWireBindings',
        version: '1.0',
        service: new LWCWireBindingsService(),
    };
}
